<template>
  <div class="networkSearchItem">
    <span
      v-if="!data.avatar"
      class="networkSearchItemImage"
      :style="{
        backgroundImage: `url('${getAvatarLink(
          data.avatar,
          getDefaultAvatar($role.CORP),
        )}')`,
      }"
    ></span>
    <div v-else class="center">
      <img :src="getThumbnailUrl(data.avatar)" alt="Thumbnail">
    </div>
    <div class="networkSearchItemText">
      <h3 class="networkSearchItemTitle">{{ data.name }} &nbsp;</h3>
      <h5 class="networkSearchItemDesc">{{ data.company }} &nbsp;</h5>
      <div class="groupBtn">
        <button class="networkSearchItemButton" @click="viewProfile">
          프로필 보기
        </button>
        <button
          class="networkSearchItemButton blue"
          @click="showApply"
          v-if="user.roleName != $role.ADMIN"
        >
          신청/자문하기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveApiUrl } from "@/data/url";
export default {
  name: "ItemSearchCorp",
  components: {},
  props: ["data"],
  data() {
    return {
      user: this.$store.state.auth.user,
    };
  },
  methods: {
    viewProfile() {
      this.$emit("viewProfile");
    },
    showApply() {
      this.$emit("showApply");
    },
    getThumbnailUrl(avatar) {
      return resolveApiUrl(`/api/profile/${avatar}.jpg`);
    }
  },
};
</script>

<style>
    .center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 208px;
    }
    .center img {
        max-width: 100%!important;
        max-height: 100%!important;
        object-fit: cover!important;
    }
</style>
